import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';

// Pub / Club workspace — NAVIGATION ONLY.
//
// A horizontal tab strip over the pub screens, the same shape as the
// Restaurant Setup and Restro Reports workspaces. Every tab navigates to an
// existing route; no page, permission or data behaviour changes here.
//
// One tab-strip pattern in the product rather than three that drift apart.
const TABS = [
  {
    label: 'Card Requests',
    path: '/admin/PubCardRequests',
    menuKey: 'PubCardRequest',
  },
  {
    label: 'Card Report',
    path: '/admin/PubCardReport',
    menuKey: 'PubCardRequest',
  },
  {
    label: 'Card Ledger',
    path: '/admin/PubCardLedger',
    menuKey: 'PubCardRequest',
  },
];

// Same visibility rule as the sidebar: master admin sees all, otherwise the
// stored permission grants decide; fail-open when no permission list exists.
//
// All three share the PubCardRequest key on purpose - whoever may raise a card
// request may read what came of it, and a key of its own would have to be
// granted to every existing user again before the tab appeared for anybody.
const allowedTabs = () => {
  let user = null;
  try {
    user = JSON.parse(sessionStorage.getItem('user'));
  } catch (_) {}
  if (user?.isMaster) return TABS;

  const raw = sessionStorage.getItem('permissions');
  if (!raw) return TABS;
  try {
    const keys = new Set(JSON.parse(raw).map((p) => p.menuKey));
    return TABS.filter((t) => keys.has(t.menuKey));
  } catch (_) {
    return TABS;
  }
};

// For the header search - the same filter the strip uses. See
// RestaurantMastersLayout.
export const allowedPubCardTabs = () => allowedTabs();

export default function PubCardLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = React.useMemo(allowedTabs, []);
  const current = location.pathname.replace(/\/+$/, '');
  const activeIdx = tabs.findIndex(
    (t) => current === t.path || current.startsWith(t.path + '/'),
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Paper
        className='no-print'
        elevation={0}
        square
        sx={{
          borderBottom: '1px solid',
          borderColor: 'divider',
          px: { xs: 1, sm: 2 },
          pt: 1,
          bgcolor: 'background.paper',
        }}>
        <Typography
          variant='subtitle2'
          sx={{ fontWeight: 700, color: 'text.secondary', mb: 0.5 }}>
          Pub / Club
        </Typography>
        <Tabs
          value={activeIdx < 0 ? false : activeIdx}
          onChange={(_, v) => navigate(tabs[v].path)}
          variant='scrollable'
          scrollButtons='auto'
          allowScrollButtonsMobile
          sx={{
            minHeight: 40,
            '& .MuiTab-root': {
              minHeight: 40,
              textTransform: 'none',
              fontWeight: 600,
            },
          }}>
          {tabs.map((t) => (
            <Tab key={t.path} label={t.label} />
          ))}
        </Tabs>
      </Paper>

      <Outlet />
    </Box>
  );
}
